export default "__VITE_ASSET__DyCsqSHO__"